import React, { useEffect, useState } from "react";
import { subscribeToRequests } from "src/services/requestActivity";

const GlobalLoader = () => {
  const [activeRequests, setActiveRequests] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeToRequests(setActiveRequests), []);

  useEffect(() => {
    let timer;
    if (activeRequests > 0) {
      timer = window.setTimeout(() => setVisible(true), 180);
    } else {
      setVisible(false);
    }
    return () => window.clearTimeout(timer);
  }, [activeRequests]);

  if (!visible) return null;

  return (
    <div
      className="global-loader"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="global-loader__panel">
        <span className="global-loader__spinner" aria-hidden="true" />
        <span className="global-loader__text">Please wait…</span>
      </div>
    </div>
  );
};

export default GlobalLoader;
